import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class DataManagementService {
  baseUrl = 'data-management-job';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  getDocumentCount = (searchCriteria) => BaseService.get({ url: `${this.baseUrl}/get-document-count?searchCriteria=${searchCriteria}` });
  downloadExported = (id) => Utils.file.attachment.download(`${this.baseUrl}/download-exported/${id}`);
  save = (document) => BaseService.post({ url: `${this.baseUrl}/save`, data: document });
}

export default new DataManagementService()
